import React from "react";
import { Button, makeStyles } from "@material-ui/core";

// Define a custom hook for styles that accepts props
const useStyles = makeStyles((theme) => ({
  customButton: (props) => ({
    borderRadius: "20px",
    textTransform: "none", // Preserves the text casing
    backgroundColor: props.color || "#fff", // Apply passed color or default to white
    color: props.textColor || "#000", // Apply passed text color or default to black
    border: props.hasBorder ? "1px solid #000" : "none", // Conditionally apply border
    "&:hover": {
      backgroundColor: props.hoverColor || "#000", // Apply passed hover color or default to black
      color: props.hoverTextColor || "#fff", // Default white text on hover
    },
  }),
}));

// CustomButton component
const CustomButton = ({
  children,
  color,
  hoverColor,
  textColor = "#000", // Default black text
  hoverTextColor = "#fff", // Default white text on hover
  hasBorder = false, // Control the border with default as false
  onClick,
  ...props
}) => {
  const classes = useStyles({
    color,
    hoverColor,
    textColor,
    hoverTextColor,
    hasBorder,
  });

  return (
    <Button
      variant="contained"
      className={classes.customButton}
      onClick={onClick}
      {...props} // Spread additional props for flexibility
    >
      {children}
    </Button>
  );
};

export default CustomButton;
